import {
	IconCompat as Icon,
	IPivotItemProps,
	PivotItem,
	SpinnerCompat as Spinner,
	StackCompat as Stack,
} from 'components/FluentUICompat';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {
	getCheckIfSearchNeeded,
	SearchStateEntity,
} from 'features/Search/SearchPage';
import {TFunction} from 'i18next';

type SearchPivotItemProps = {
	t: TFunction;
	entityName: string;
	searchText: string;
	currentViewKey: string;
	currentTop: number;
	loading: boolean;
	searchStateEntity?: SearchStateEntity;
	items?: any[];
};

export const getSearchPivotItem = (props: SearchPivotItemProps) => {
	const {
		t,
		entityName,
		searchText,
		currentViewKey,
		currentTop,
		searchStateEntity,
		loading,
		items,
	} = props;

	const itemCount = getItemCount(currentTop, items);

	const renderItemLink = (
		props?: IPivotItemProps,
		defaultRenderer?: (props?: IPivotItemProps) => JSX.Element | null,
	) =>
		renderSearchPivot(
			loading,
			searchText,
			currentTop,
			searchStateEntity,
			props,
			defaultRenderer,
		);

	return (
		<PivotItem
			headerText={t(entityName)}
			itemKey={entityName.toLowerCase()}
			itemIcon={getPivotIcon(currentViewKey, entityName.toLowerCase())}
			itemCount={itemCount}
			onRenderItemLink={renderItemLink}
		/>
	);
};

const renderSearchPivot = (
	isLoading: boolean,
	searchText: string,
	currentTop: number,
	searchStateEntity?: SearchStateEntity,
	props?: IPivotItemProps,
	defaultRenderer?: (props?: IPivotItemProps) => JSX.Element | null,
) => {
	if (!props || !defaultRenderer) {
		return null;
	}
	const isNotSearch = getCheckIfSearchNeeded(
		searchText,
		currentTop,
		searchStateEntity,
	);

	const renderedItem = defaultRenderer({
		...props,
		itemCount: isLoading || isNotSearch ? undefined : props.itemCount,
	});

	return (
		<Stack horizontal tokens={{childrenGap: 5}}>
			{isNotSearch && <Icon iconName='Search' />}
			{renderedItem as any}
			{isLoading && <Spinner />}
		</Stack>
	);
};
const getItemCount = (currentTop: number, items?: any[]) =>
	(items ?? []).length;

export const getPivotIcon = (currentViewKey: string, viewKey: string) =>
	currentViewKey === viewKey ? 'List' : undefined;
